(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'MyTripsAccountClientTravelStyles',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('.reset-travel-styles').on('click', function resetTravelStyles(e) {
				e.preventDefault();
			
			if ($('.travel-style-check').is(':checked')) { 
				$('.travel-style-check').prop('checked', false);
			}
		});
	};

}(jQuery, window.Adzuki || {}));